import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => {

	return {
		tabRoot: {
			margin                  : "1rem 0",
			"& .mantine-Tabs-root " : {
				height: "100%"
			},
			"& .mantine-Tabs-tab": {
				outline          : theme.other.darkMode ? `1px solid ${ theme.other.paletteNew.darkModeWhite20 } ` : `1px solid ${ theme.other.paletteNew.secondaryLightGrey }`,
				border           : "none",
				padding          : "0.7rem 1.5rem",
				borderRadius     : "10px",
				cursor           : "pointer",
				// width            : "50%",
				backgroundColor  : theme.other.darkMode ? theme.other.paletteNew.darkModeDarkGrey20 : theme.other.paletteNew.secondaryBackgroundGrey,
				color            : theme.other.darkMode ? theme.other.paletteNew.darkModeWhite80 : theme.other.paletteNew.secondaryBlack,
				"&[data-active]" : {
					color      : theme.other.darkMode ? `${ theme.other.paletteNew.secondaryWhite } !important` : `${ theme.other.paletteNew.primaryDarkBlue } !important `,
					background : theme.other.darkMode ? theme.other.paletteNew.darkModeDarkBlue50 : theme.other.paletteNew.primaryDarkBlue10,
					outline    : `1px solid ${ theme.other.paletteNew.primaryDarkBlue }`
				}
			}
		},
		backgroundWrapper: {
			backgroundColor: "inherit"
		},
		tabList: {
			 display: "flex", gap: "1.5rem"
		},
		tabText: {
			color         : "inherit",
			// fontSize   : theme.other.isMobile ? "1.2rem" : "inherit",
			whiteSpace    : "nowrap",
			letterSpacing : "normal !important",
			textTransform : "capitalize !important"
		},
		tabPanel: {
			height       : "85%",
			marginTop    : "1rem",
			borderRadius : "1.5rem",
			padding      : "2rem 0"
		}
	};
} );
